import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-list-data',
  templateUrl: './list-data.component.html',
  styleUrls: ['./list-data.component.css']
})
export class ListDataComponent implements OnInit {
    public listDataKeyno;

    listKeyno;

    public listDataLangButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'listdatalang', gotoParms: () => this.edit!.listdata_keyno ?? '' }];

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.listDataKeyno = this.stateService.getStateParams()['listdata_keyno'];
        this.listKeyno = this.stateService.getStateParams()['list_keyno'];
    }

    private async loadEdit() {
        if (!!this.listDataKeyno && !!this.listKeyno) {
            this.edit = (await this.datatask.Post(2719, {
                listdata_keyno: this.listDataKeyno,
                list_keyno: this.listKeyno
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2720, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    listdata_keyno: string;
    listdatalang_name: string;
    list_keyno: string;
}
